module.exports = "https://cdn.hellotech.com/client-assets/premium-antivirus_18a1c21b3630982d1055984c42b43bc9.svg";